import { useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { ShieldCheck, LogOut, Check } from "lucide-react";

export function Paywall() {
  const { user, logout } = useAuth();
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch {
      toast.error("Bezahlung konnte nicht gestartet werden.");
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0A1128] px-6 py-12" data-testid="paywall">
      <div className="w-full max-w-md rounded-3xl border border-[#C5A059]/30 bg-white p-7 shadow-[0_18px_50px_rgba(0,0,0,0.3)]">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FBF8F1]">
          <ShieldCheck className="text-[#C5A059]" size={30} />
        </div>
        <h1 className="mt-5 text-center font-display text-3xl font-semibold tracking-tight text-[#0A1128]">Dein Zugang</h1>
        <p className="mt-2 text-center text-sm text-[#718096]">
          Hallo {user?.name || "Berater"}, um dein Empfehlungs-Dashboard weiter zu nutzen, aktiviere bitte deinen Zugang.
        </p>

        <div className="mt-6 rounded-2xl border border-[#C5A059]/30 bg-[#FBF8F1] p-5 text-center">
          <p className="text-5xl font-extrabold leading-none text-[#0A1128]">9,90&nbsp;€</p>
          <p className="mt-1 text-sm font-medium text-[#8a6d2f]">pro Monat · jederzeit kündbar</p>
        </div>

        <ul className="mt-5 space-y-2.5">
          {["Eigene Empfehlungsseite & QR-Poster", "Empfehlungen & Prämien verwalten", "Push-Benachrichtigungen", "Alle Branchen-Themen & Slogans"].map((t) => (
            <li key={t} className="flex items-start gap-2.5 text-sm text-[#4A5568]">
              <Check className="mt-0.5 shrink-0 text-[#276749]" size={18} /> {t}
            </li>
          ))}
        </ul>

        <button
          data-testid="paywall-checkout-btn"
          onClick={start}
          disabled={busy}
          className="mt-6 flex h-14 w-full items-center justify-center gap-2 rounded-full bg-[#C5A059] text-base font-semibold text-[#0A1128] shadow-[0_8px_24px_rgba(197,160,89,0.3)] transition-all active:scale-[0.99] disabled:opacity-60"
        >
          {busy ? "Weiterleitung …" : "Jetzt freischalten"}
        </button>
        <p className="mt-3 text-center text-[11px] text-[#A0AEC0]">Sichere Zahlung über Stripe. Testkarte: 4242 4242 4242 4242</p>

        <button data-testid="paywall-logout-btn" onClick={logout} className="mt-5 flex w-full items-center justify-center gap-1.5 text-sm font-semibold text-[#718096]">
          <LogOut size={15} /> Abmelden
        </button>
      </div>
    </div>
  );
}

export default Paywall;
